import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {productByIdType} from "./__graphql-types__/index.ts";

// Query to get product by id
export const PRODUCT_BY_ID_QUERY: GqlOperation<
    productByIdType["response"],
    productByIdType["variables"]
> = gqlOp(gql`
    query productById($id: ID) {
        product(id: $id) {
            id
            name
            isActive
            description
            extProductID
            validationBillingCountries
            prices {
                currency
                extProductID
                id
                recurringInterval
                recurringIntervalCount
                type
                unitAmount
            }
        }
    }
`);
